import { ReactNode } from 'react';

export const NodeUl = (children: ReactNode) => <ul className="pl-5">{children}</ul>;
